import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const Icon = (props) => {
  const { iconDSFR = "", isHidden = true, groupDSFR, size = "md", className = "", sx = {}, ...others } = props;

  if (!iconDSFR) {
    return null;
  }

  return (
    <Box
      component="span"
      {...others}
      className={`fr-icon-${iconDSFR} fr-icon--${size}${className ? ` ${className}` : ""}`}
      sx={sx}
      aria-hidden={isHidden}
    />
  );
};

Icon.propTypes = {
  iconDSFR: PropTypes.string,
  groupDSFR: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  isHidden: PropTypes.bool,
  className: PropTypes.string,
  sx: PropTypes.shape(),
};

export default Icon;
